import React from 'react'

import './features.css';

import Tilt from 'react-parallax-tilt';

import Line from '../assets/features/curve.png';
import Line2 from '../assets/features/curve2.png';

import FeatureData from '../helper/featureData';

const features = () => {
    return (
        <>
            <div className="container hero-features">
                <div className="hero-feature-text">
                    <h1>Exciting Features In Reward Pro</h1>
                </div>
                <div className="hero-line">
                    <img src={Line2} alt="" />
                </div>
            </div>
            <div className="container featured">
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 featured-card">
                    {
                        FeatureData.map((value, index) => (
                            <Tilt style={{ margin: "0 auto" }}>
                                <div className="col-md card" key={index}>
                                    <div className="card-img">
                                        <img src={value.img} alt="" />
                                    </div>
                                    <div className="card-title">
                                        <p>{value.title}</p>
                                    </div>
                                    <div className="card-desc" id="card-d" >
                                        <p>{value.desc}</p>
                                    </div>
                                </div>
                            </Tilt>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default features
